import { StripeElementsOptions } from '@stripe/stripe-js';
import KHTekaMediumSupport from '../assets/fonts/KHTeka-Medium.woff';
import KHTekaMedium from '../assets/fonts/KHTeka-Medium.woff2';

export const stripeFonts: StripeElementsOptions['fonts'] = [
  {
    family: 'KH Teka',
    weight: '400',
    src: `url('${KHTekaMedium}') format('woff2'), url('${KHTekaMediumSupport}') format('woff')`,
  },
];
